<template>
    <div v-if="showUpdateNotification" class="fixed bottom-4 right-4 z-50">
        <div class="bg-blue-500 text-white p-4 rounded-lg shadow-lg max-w-sm">
            <div class="flex items-center justify-between">
                <div class="flex items-center">
                    <div
                        class="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"
                    ></div>
                    <span class="text-sm font-medium">
                        {{ updateMessage }}
                    </span>
                </div>
                <button
                    @click="dismissNotification"
                    class="ml-2 text-white hover:text-gray-200"
                >
                    <svg
                        class="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M6 18L18 6M6 6l12 12"
                        ></path>
                    </svg>
                </button>
            </div>
            <div v-if="showReloadButton" class="mt-2">
                <button
                    @click="reloadApp"
                    class="bg-white text-blue-500 px-3 py-1 rounded text-sm font-medium hover:bg-gray-100"
                >
                    Recargar ahora
                </button>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from "vue";

const showUpdateNotification = ref(false);
const showReloadButton = ref(false);
const updateMessage = ref("");

const handleUpdateFound = () => {
    showUpdateNotification.value = true;
    updateMessage.value = "Descargando nueva versión...";
    showReloadButton.value = false;
};

const handleUpdated = () => {
    showUpdateNotification.value = true;
    updateMessage.value = "Nueva versión disponible";
    showReloadButton.value = true;
};

const dismissNotification = () => {
    showUpdateNotification.value = false;
};

const reloadApp = () => {
    window.location.reload();
};

onMounted(() => {
    // Escuchar eventos del Service Worker
    document.addEventListener("sw-update-found", handleUpdateFound);
    document.addEventListener("sw-updated", handleUpdated);
});

onUnmounted(() => {
    // Limpiar event listeners
    document.removeEventListener("sw-update-found", handleUpdateFound);
    document.removeEventListener("sw-updated", handleUpdated);
});
</script>
